import React from "react";
import { useNavigate } from "react-router";

const ScrollToSection = ({ sectionId, label }: { sectionId: string, label: string }) => {
  const navigate = useNavigate();

  const handleScrollToSection = (e: React.MouseEvent) => {
    e.preventDefault();

    // First, navigate to the homepage
    navigate("/");  // Redirect to the homepage (adjust if necessary)

    // Delay the scroll to ensure the page is loaded
    setTimeout(() => {
      const section = document.getElementById(sectionId);
      if (section) {
        const yOffset = -80; // Adjust for your header height
        const y = section.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }, 200); // Small delay to ensure the page is fully loaded
  };

  return (
    <a
      onClick={handleScrollToSection}
      className="font-medium no-underline  cursor-pointer"
    >
      <span className="font-['DM_Sans'] font-medium text-base leading-none tracking-normal text-[#303030] hover:text-red-600 transition-colors duration-200 cursor-pointer">
        {label}
      </span>
    </a>
  );
};

export default ScrollToSection;
